import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/layout/Layout";
import { IndexingControl } from "@/components/common/IndexingControl";
import { ProtectedRoute } from "@/admin/ProtectedRoute";
import Home from "@/pages/Home";
import About from "@/pages/About";
import WhatWeDo from "@/pages/WhatWeDo";
import ProductAreas from "@/pages/ProductAreas";
import OurBrands from "@/pages/OurBrands";
import ForSuppliers from "@/pages/ForSuppliers";
import ForBuyers from "@/pages/ForBuyers";
import QualityCompliance from "@/pages/QualityCompliance";
import Contact from "@/pages/Contact";
import Health from "@/pages/Health";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import LegalPage from "@/pages/LegalPage";
// Admin
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Dashboard from "@/admin/Dashboard";
import Submissions from "@/admin/Submissions";
import InsightsAdmin from "@/admin/InsightsAdmin";
import Brands from "@/admin/Brands";
import ContactInfo from "@/admin/ContactInfo";
import SeoAdmin from "@/admin/SeoAdmin";
import LegalAdmin from "@/admin/LegalAdmin";
import Users from "@/admin/Users";
import Audit from "@/admin/Audit";
import Account from "@/admin/Account";
import { ForgotPassword, ResetPassword } from "@/admin/PasswordReset";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <IndexingControl />
          <Routes>
            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/what-we-do" element={<WhatWeDo />} />
              <Route path="/product-areas" element={<ProductAreas />} />
              <Route path="/our-brands" element={<OurBrands />} />
              <Route path="/for-suppliers" element={<ForSuppliers />} />
              <Route path="/for-buyers" element={<ForBuyers />} />
              <Route path="/quality-compliance" element={<QualityCompliance />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
              <Route path="/privacy" element={<LegalPage slug="privacy" />} />
              <Route path="/cookies" element={<LegalPage slug="cookies" />} />
              <Route path="/terms" element={<LegalPage slug="terms" />} />
              <Route path="/regulated-products-disclaimer" element={<LegalPage slug="regulated-products-disclaimer" />} />
            </Route>

            {/* Azeka Health holding page (standalone) */}
            <Route path="/health" element={<Health />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/forgot" element={<ForgotPassword />} />
            <Route path="/admin/reset-password" element={<ResetPassword />} />
            <Route element={<ProtectedRoute />}>
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="submissions" element={<Submissions />} />
                <Route path="insights" element={<InsightsAdmin />} />
                <Route path="brands" element={<Brands />} />
                <Route path="contact" element={<ContactInfo />} />
                <Route path="seo" element={<SeoAdmin />} />
                <Route path="legal" element={<LegalAdmin />} />
                <Route path="users" element={<Users />} />
                <Route path="audit" element={<Audit />} />
                <Route path="account" element={<Account />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
